import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { useCadStore } from '../store/cadStore';

function buildGeometry(type, seg) {
    switch (type) {
        case 'sphere': case 'sphere_small': return new THREE.SphereGeometry(type === 'sphere' ? 0.5 : 0.2, seg, seg);
        case 'cylinder': case 'tube': return new THREE.CylinderGeometry(type === 'tube' ? 0.3 : 0.5, type === 'tube' ? 0.3 : 0.5, 1, seg);
        case 'cylinder_thin': return new THREE.CylinderGeometry(0.1,  0.1,1, seg);
        case 'torus': return new THREE.TorusGeometry(0.5,  0.2, seg, seg);
        case 'cone': case 'pyramid': return new THREE.ConeGeometry(type === 'pyramid' ? 0.6 :  0.5, 1, type === 'pyramid' ? 4 : seg);
        case 'diamond': return new THREE.OctahedronGeometry(0.6);
        case 'gem': return new THREE.DodecahedronGeometry(0.55);
        default: return new THREE.BoxGeometry(1,1,1);
    }
}

export default function LODMesh({ part }) {
    const lodRef = useRef(null);
    const mat = useRef(new THREE.MeshStandardMaterial({ color: part.color || '#3b82f6', roughness: 0.35 }));
    const selected = useCadStore((s) => s.selectedPartId === part.id);
    const setSelected = useCadStore((s) => s.setSelectedPart);

    if (!lodRef.current) {
        const lod = new THREE.LOD();
        const high = new THREE.Mesh(buildGeometry(part.type, 40));
        const low = new THREE.Mesh(buildGeometry(part.type, 8));
        high.material = mat.current;
        low.material = mat.current;
        high.castShadow = true; low.receiveShadow = true;
        lod.addLevel(low, 0);
        lod.addLevel(high, 60);
        lodRef.current = lod;
    }

    useFrame(() => {
        const lod = lodRef.current;
        if (!lod) return;
        lod.position.set(...part.position);
        lod.scale.set(...part.scale);
        lod.rotation.set(...part.rotation || [0,0,0]);
        lod.visible = !part.hidden;
        mat.current.color.setHex(part.color || (selected ? '#1d4ed8' : '#3b82f6'));
        const cam = window.__roocad_controls?.object;
        if (cam) lod.update(cam);
    });

    return <primitive object={lodRef.current} onPointerDown={(e) => { e.stopPropagation(); setSelected(part.id); }} />;
}